var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.52,
    height: 26.519,
    viewBox: "0 0 26.52 26.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M26.2,24.636l-7.541-7.541a10.517,10.517,0,1,0-1.562,1.562L24.633,26.2A1.1,1.1,0,1,0,26.2,24.636ZM10.5,18.787A8.287,8.287,0,1,1,18.784,10.5,8.3,8.3,0,0,1,10.5,18.787Z",
    transform: "translate(0 -0.003)",
    fill: "#ee7404"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.cc94fa945786c6d15ab4f44c6bbd73d6.svg";
export { ForwardRef as ReactComponent };